import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { isTicketAvailable } from "../../components/helpers/TicketHelpers";

const isFull = (event) => (event.maxParticipants - event.participantsCount) <= 0;

const isPast = (event) => {
    const now = new Date();
    const eventEndDate = new Date(`${event.endDate || event.startDate}T${event.endTime}:00`).getTime();
    return now.getTime() > eventEndDate;
};

const isTooLateToRegister = (event) => {
    const now = new Date();
    const eventStartDate = new Date(`${event.startDate}T${event.startTime}:00`).getTime();
    const oneHourBeforeStart = new Date(eventStartDate - (60 * 60 * 1000));
    return now.getTime() > oneHourBeforeStart.getTime();
};

const isCancelled = (event) => event.status === 'Cancelled';

const isSoldOut = (event) => {
    if (event.isFree) return false;
    if (!event.ticketTypes || event.ticketTypes.length === 0) return true;
    return !event.ticketTypes.some(isTicketAvailable);
};

const isNotAvailable = (event) => {
    return isCancelled(event) || isFull(event) || isPast(event) || isTooLateToRegister(event) || isSoldOut(event);
};

const getCheapestTicketPrice = (event, t, alwaysShowFromLabel) => {
    if (!event.ticketTypes || event.ticketTypes.length === 0) {
        return t('no_tickets');
    }
    const availableTickets = event.ticketTypes.filter(isTicketAvailable);
    if (availableTickets.length === 0) {
        return t('ticket.sold');
    }
    const grossPrices = availableTickets.map(ticket => ticket.price * (1 + ticket.vatPercentage / 100));
    const minGrossPrice = Math.min(...grossPrices);
    const maxGrossPrice = Math.max(...grossPrices);
    if (alwaysShowFromLabel) {
        return `${t('ticket.buy_from', 'Bilety od')} ${minGrossPrice.toFixed(2)} zł`;
    }
    if (minGrossPrice.toFixed(2) === maxGrossPrice.toFixed(2)) {
        return `${minGrossPrice.toFixed(2)} zł`;
    }
    return `${t('ticket.from')} ${minGrossPrice.toFixed(2)} zł`;
};

const BuyTicketButton = ({ event, onClick, alwaysShowFromLabel = false, ...rest }) => {
    const { t, i18n } = useTranslation("default");
    const reserveLabel = t('event.reserve_seat', i18n.language?.startsWith('en') ? 'Reserve a seat' : 'Zarezerwuj miejsce');
    // Cena jest pokazana w opisie wydarzenia — na przycisku samo działanie (albo powód niedostępności)
    const soldOut = !event.isFree && isSoldOut(event);

    return (
        <Button color={'white'} w={'full'} h={{ base: '52px', md: '56px' }} alignSelf={"center"}
            bgColor={'brand.500'} _hover={{ bgColor: 'brand.600' }} gap={'10px'} borderRadius={"14px"}
            fontWeight={'700'} fontSize={{ base: '16px', md: '18px' }} lineHeight={'100%'}
            onClick={onClick}
            disabled={isNotAvailable(event)}
            {...rest}
        >
            {isTooLateToRegister(event)
                ? t('register.close')
                : <>
                    {soldOut ? getCheapestTicketPrice(event, t, alwaysShowFromLabel) : reserveLabel}
                </>
            }
        </Button>
    );
};

export default BuyTicketButton;
export { isCancelled, isNotAvailable };
